export const issuesList = (state) => state.issue.issuesList;

export const issuesByIds = (state) => state.issue.listById;
export const selectedProjectId = (state) => state.checklists.selectedProjectId;
export const pdfLoading = (state) => state.issue.pdfLoading;
